import {type Tokens, Renderer} from '@time-webkit/marked';

export default class MentionableRenderer extends Renderer {
    public code() {
        // Code blocks can't contain mentions
        return '\n';
    }

    public hr() {
        return '\n';
    }

    public tablerow({text}: Tokens.TableRow) {
        return text;
    }

    public codespan() {
        // Code spans can't contain mentions
        return ' ';
    }

    public br() {
        return '\n';
    }

    public link({text}: Tokens.Link) {
        return ' ' + text + ' ';
    }

    public image({text}: Tokens.Image) {
        return ' ' + text + ' ';
    }

    public text({text}: Tokens.Text) {
        return text;
    }
}
